import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, push, ref, remove } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "Admin",
  });

  /* ================= FETCH USERS ================= */
  useEffect(() => {
    const usersRef = ref(db, "passwords");

    onValue(usersRef, (snap) => {
      if (snap.exists()) {
        const list = Object.entries(snap.val()).map(([id, data]) => ({
          id,
          ...data,
        }));
        setUsers(list);
      } else {
        setUsers([]);
      }
    });
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  /* ================= SAVE USER ================= */
  const handleSave = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.phone || !form.password) {
      alert("सभी फ़ील्ड भरना अनिवार्य है");
      return;
    }

    await push(ref(db, "passwords"), {
      ...form,
      createdAt: Date.now(),
    });

    setForm({
      name: "",
      email: "",
      phone: "",
      password: "",
      role: "Admin",
    });
  };

  /* ================= DELETE ================= */
  const handleDelete = (id) => {
    if (!window.confirm("Delete this user?")) return;
    remove(ref(db, `passwords/${id}`));
  };

  /* ================= ROLE FILTERS ================= */
  const admins = users.filter((u) => u.role === "Admin");
  const employees = users.filter((u) => u.role === "Employee");
  const viewers = users.filter((u) => u.role === "Dashboard View");

  /* ================= TABLE COMPONENT ================= */
  const UserTable = ({ title, data }) => (
    <div className="card shadow-sm mb-4">
      <div className="card-header fw-bold">{title}</div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover mb-0">
          <thead className="table-light text-center">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No data found
                </td>
              </tr>
            ) : (
              data.map((u, i) => (
                <tr key={u.id}>
                  <td className="text-center">{i + 1}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td className="text-center">{u.phone}</td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(u.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="container mt-4">

      <h4 className="mb-3 text-primary">🔐 Admin User Management</h4>

      {/* ================= CREATE USER ================= */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header fw-bold">➕ Create New User</div>

        <div className="card-body">
          <form onSubmit={handleSave}>
            <div className="row g-3">

              <div className="col-md-3">
                <label className="form-label">Name *</label>
                <input
                  className="form-control"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">Phone *</label>
                <input
                  className="form-control"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">Password *</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">Role *</label>
                <select
                  className="form-select"
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                >
                  <option>Admin</option>
                  <option>Employee</option>
                  <option>Dashboard View</option>
                  <option>Partner</option>
                </select>
              </div>
            </div>

            <div className="text-end mt-3">
              <button className="btn btn-success px-4">
                Save User
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* ================= ROLE WISE TABLES ================= */}
      <UserTable title="👑 Admin Users" data={admins} />
      <UserTable title="🧑‍💼 Employee Users" data={employees} />
      <UserTable title="👁 Dashboard View Users" data={viewers} />

    </div>
  );
};

export default AdminUsers;
